import React, { Component, useRef, useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import LoadingAnimation from '../LoadingAnimation.js';
import * as MastersUtils from './MastersUtils.js';
import NavBarMini from '../NavBarMini.js';
import Footer from '../Footer.js';

import { collection, query, where, getDoc, getDocs, setDoc, updateDoc, doc } from "firebase/firestore";
import { db } from '../../firebase.js';

import mastersData2023 from './mastersData2023.json';
import mastersData2024 from './mastersData2024.json';
import mastersData2025 from './mastersData2025.json';

const currentYear = '2026'
let mastersYear = '2026'
let mastersYearData = 'data2026'

const defaultMastersData = {
  currentRound: '1000',
  statusRound: 'NNNNN',
  wallClockTime: '0',
  player: [],
  yardages: [],
  pars: []
}

const AugustaLeaderboard = () => {
  const [leaderboardReady, setLeaderboardReady] = useState(false);
  const [masters, setMasters] = useState(defaultMastersData);
  const [users, setUsers] = useState([]);
  const [players, setPlayers] = useState([]);
  const { year } = useParams();

  useEffect(() => {
    mastersYear = year || currentYear
    mastersYearData = `data${mastersYear}`

    document.title = `${mastersYear} 1A Masters Pool`;

    getUsers();
    getPlayers();
    getMastersData();

    // Just do this at the beginning of the year to get the field
    // updateData()

    setLeaderboardReady(true);
  }, [])

  // Fetch users from Firebase DB
  const getUsers = async () => {
    const docs = await getDocs(collection(db, "masters", mastersYearData, "users"));

    let users = [];
    docs.forEach((doc) => {
      const userID = doc.id;
      const user = doc.data();
      user.id = userID;
      users.push(user);
    });

    setUsers(users);
  }

  const getPlayers = async () => {
    const response = await fetch(`https://www.masters.com/en_US/cms/feeds/players/${mastersYear}/players.json`);
    const data = await response.json();
    let players = data.players;
    players.sort((a, b) => a.last_name.localeCompare(b.last_name));
    setPlayers(players);
  }

  // Fetch Masters data from API endpoint
  const getMastersData = async () => {
    const localData = { '2023': mastersData2023, '2024': mastersData2024, '2025': mastersData2025 };
    if (localData[mastersYear]) {
      setMasters(localData[mastersYear].data);
      return;
    }
    fetch(`https://www.masters.com/en_US/scores/feeds/${mastersYear}/scores.json`)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.player) {
          setMasters(data.data);
        }
      })
  }

  function displayPlayerTableRows () {
    if (mastersYear !== currentYear || MastersUtils.tournamentStarted()) {
      let sortedPlayers = MastersUtils.sortPlayers(masters);

      let playerElements = sortedPlayers.map((player, place) => displayPlayerRow(player, place) )

      return playerElements;
    } else {
      const teetimeByID = {};
      (masters.player || []).forEach((p) => { if (p.teetime) teetimeByID[p.id] = p.teetime; });

      return players.map((player) => {
        const teetime = teetimeByID[player.id];
        return (
          <tr key={player.id}>
            <td className="masters-table-data-name"><div className='masters-player-cell-name-line'><p className="masters-player-cell-flag">{ MastersUtils.emojiFlagForCountryCode(player.countryCode) }</p><p className="masters-player-cell-name">{ player.display_name.toUpperCase() }</p></div></td>
            { Array.from({ length: 18 }, (_, i) => <td key={i} className="masters-table-data hole"><span>&#160;</span></td>) }
            { teetime
              ? <td className="masters-table-data total thru teetime-col" colSpan={2}><span>{ teetime }</span></td>
              : <><td className="masters-table-data total extra-width"><span>&#160;</span></td><td className="masters-table-data total extra-width"><span>&#160;</span></td></>
            }
          </tr>
        );
      });
    }
  }

  function displayPlayerRow (player, place) {
    let roundNumber = MastersUtils.getCurrentRoundNumber(masters)

    let winner = false;
    if (MastersUtils.tournamentEnded(masters) && place === 0) {
      winner = true
    }
    return (
        <tr className={ winner ? 'winner' : '' } key={player.id}>
          <td className="masters-table-data-name"><div className='masters-player-cell-name-line'><p className="masters-player-cell-flag">{ MastersUtils.emojiFlagForCountryCode(player.countryCode) }</p><p className="masters-player-cell-name">{ player.display_name.toUpperCase() }</p></div></td>
          { MastersUtils.playerRoundScores(player, roundNumber, masters.pars.round1) }
          { MastersUtils.playerGrossScore(player) }
          { MastersUtils.playerThru(player) }
        </tr>
    );
  }

  if (leaderboardReady == false) {
    return (
      <div className="Masters">
        <NavBarMini alwaysShown={true} />
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Masters">
        <NavBarMini alwaysShown={true} />
        <div className="masters-content">
          <div className="masters-header">
            <div className="masters-header-top">
              <a className="masters-type" target="_blank" rel="noopener noreferrer" href="https://www.masters.com/">The Masters</a>
              <p className={ "masters-title-standard" }>{ mastersYear } Masters</p>
              <a className="masters-type" href={ mastersYear == '2026' ? "/masters" : `/masters/${mastersYear}` }>Pool Leaders</a>
              <div className="masters-past-year-leaderboards">
                { mastersYear == '2023' ? <span className="masters-type masters-year-selected">2023</span> : <a className="masters-type" href="/masters/augusta/2023">2023</a> }
                { mastersYear == '2024' ? <span className="masters-type masters-year-selected">2024</span> : <a className="masters-type" href="/masters/augusta/2024">2024</a> }
                { mastersYear == '2025' ? <span className="masters-type masters-year-selected">2025</span> : <a className="masters-type" href="/masters/augusta/2025">2025</a> }
                { mastersYear == '2026' ? <span className="masters-type masters-year-selected">2026</span> : <a className="masters-type" href="/masters/augusta">2026</a> }
              </div>
            </div>
          </div>


          <div className="masters-body">
            <div className="masters-table-container">
              <div className="cut-off-half"><div className="masters-table-heading-title"><span>LEADERS</span></div></div>

              <table className="table masters-table">
                <thead className="masters-table-heading-hole">
                  <tr>
                    <th className="masters-table-heading-name"><span>HOLE</span></th>
                    <th className="masters-table-heading hole"><span>1</span></th>
                    <th className="masters-table-heading hole"><span>2</span></th>
                    <th className="masters-table-heading hole"><span>3</span></th>
                    <th className="masters-table-heading hole"><span>4</span></th>
                    <th className="masters-table-heading hole"><span>5</span></th>
                    <th className="masters-table-heading hole"><span>6</span></th>
                    <th className="masters-table-heading hole"><span>7</span></th>
                    <th className="masters-table-heading hole"><span>8</span></th>
                    <th className="masters-table-heading hole"><span>9</span></th>
                    <th className="masters-table-heading hole"><span>10</span></th>
                    <th className="masters-table-heading hole"><span>11</span></th>
                    <th className="masters-table-heading hole"><span>12</span></th>
                    <th className="masters-table-heading hole"><span>13</span></th>
                    <th className="masters-table-heading hole"><span>14</span></th>
                    <th className="masters-table-heading hole"><span>15</span></th>
                    <th className="masters-table-heading hole"><span>16</span></th>
                    <th className="masters-table-heading hole"><span>17</span></th>
                    <th className="masters-table-heading hole"><span>18</span></th>
                  </tr>
                </thead>
                <thead className="masters-table-heading-par">
                <tr>
                  <th className="masters-table-heading-name"><span>PAR</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>5</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>3</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>3</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>5</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>3</span></th>
                  <th className="masters-table-heading hole"><span>5</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>5</span></th>
                  <th className="masters-table-heading hole"><span>3</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                  <th className="masters-table-heading hole"><span>4</span></th>
                </tr>
                </thead>
                <thead className="masters-table-heading-total">
                <tr>
                <th className="masters-table-heading-name"><span>NAME</span></th>
                <th className="masters-table-heading"><span>TOTAL</span></th>
                <th className="masters-table-heading"><span>THRU</span></th>
                </tr>
                </thead>
                <tbody>
                  { displayPlayerTableRows() }
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Footer/>
      </div>
    );
  }

  function updateData() {
    // get the updated data
    fetch(`https://www.masters.com/en_US/scores/feeds/${mastersYear}/scores.json`)
      .then((response) => response.json())
      .then((data) => {
        let mastersData = data.data;

        // update metadata
        const dataRef = doc(db, "masters", mastersYearData);
        updateDoc(dataRef, {
          currentRound: mastersData.currentRound,
          wallClockTime: mastersData.wallClockTime,
          statusRound: mastersData.statusRound
        })

        let players = mastersData.player;

        // merge player data
        players.forEach((player) => {
          const playerRef = doc(db, "masters", mastersYearData, "players", player.id);
          setDoc(playerRef, {
            first_name: player.first_name,
            last_name: player.last_name,
            id: player.id,
            group: player.group,
            groupHistory: player.groupHistory,
            holeProgress: player.holeProgress,
            lastHoleWithShot: player.lastHoleWithShot,
            live: player.live,
            movement: player.movement,
            newStatus: player.newStatus,
            pos: player.pos,
            round1: player.round1,
            round2: player.round2,
            round3: player.round3,
            round4: player.round4,
            sort_order: player.sort_order,
            start: player.start,
            status: player.status,
            tee_order: player.tee_order,
            teetime: player.teetime,
            thru: player.thru,
            thruHistory: player.thruHistory,
            today: player.today,
            topar: player.topar,
            total: player.total,
            totalUnderPar: player.totalUnderPar
          }, { merge: true });
        })
      })
  }
}

export default AugustaLeaderboard;
